import {Box, Card, CardContent, CircularProgress, Stack, Typography} from "@mui/material";
import {CircularProgressWithLabel} from "@/global/components/CircularProgressWithLabel";

interface Props {
    label: string,
    percent: number,
}

export function LongCard({label, percent}: Props) {
    return (
        <Card
            sx={{
                width: "100%",
                background: '#F4F7FE',
                borderRadius: '20px'
            }}
        >
            <CardContent>
                <Stack
                    flexDirection={'row'}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                    gap={2}
                >
                    <Stack
                        alignItems={'center'}
                        gap={1}
                    >
                        <Typography>
                            {label}
                        </Typography>
                    </Stack>
                    <Box
                        sx={{
                            position: 'relative'
                        }}
                    >
                        <CircularProgress
                            variant={'determinate'}
                            value={100}
                            size={120}
                            thickness={2}
                            sx={{
                                position: 'absolute',
                                color: 'white',
                            }}
                        />
                        <CircularProgressWithLabel
                            variant={'determinate'}
                            size={120}
                            thickness={2}
                            value={percent}
                            sx={{
                                color: '#FF9999'
                            }}
                        />
                    </Box>
                </Stack>
            </CardContent>
        </Card>
    );
}